{
  "id": "a6de8d8c-0c98-4575-9869-1c66fe4a8c76",
  "listingId": "5f7df771-b3a1-4c19-98df-18add4e0690c",
  "playerInstanceId": "75d7856e-076a-42be-b89a-c631fa0f8d96",
  "buyerClubId": "5fde2141-dbbe-501d-859f-ae12674d9a73",
  "terms": {
    "transferAmount": 6000000.0,
    "annualSalary": 1000000.0,
    "releaseClause": 20000000.0,
    "termSeasons": 3
  },
  "submittedAt": "2026-09-28T07:53:42.601257Z",
  "cutoffAt": "2026-09-29T01:00:00Z",
  "reservationExpiresAt": "2026-10-01T01:00:00Z",
  "status": "SUBMITTED",
  "reservationId": "48b953ae-79e5-4941-b1fc-583bb744468a",
  "version": 1
}
